import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import i18n from './translation/i18n';
import { AppProvider } from './contexts/app.context';
import { ConfigProvider } from 'antd';
import theme from './theme';
import * as Sentry from '@sentry/react';

// Suppress ResizeObserver errors globally
const resizeObserverErrorHandler = (e: ErrorEvent) => {
  if (
    e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    e.message === 'ResizeObserver loop limit exceeded'
  ) {
    e.stopImmediatePropagation();
  }
};

window.addEventListener('error', resizeObserverErrorHandler);

// import 'src/App.scss';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0
    }
  }
});

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    sendDefaultPii: false,
    integrations: [],
    environment: process.env.NODE_ENV,
    release: 'erp-client-app'
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <AppProvider>
        <I18nextProvider i18n={i18n}>
          <ConfigProvider
            getPopupContainer={() => document.getElementById('root')!}
            // componentSize='small'
            theme={theme}
            form={{ colon: false }}
          >
            <App />
          </ConfigProvider>
        </I18nextProvider>
      </AppProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </BrowserRouter>
);

serviceWorkerRegistration.register();
